import React from 'react';
import { IAssignment } from '@/components/interfaces';
import { useModalManager } from 'components/common/Modal';
import BulkGradingModal from './BulkGradingModal';
import BulkGradingButton from './BulkGradingButton';
import { ScoreData } from './types';

interface BulkGradingWrapperProps extends Omit<React.HTMLProps<HTMLButtonElement>, 'className' | 'onClick' | 'type'> {
  assignment?: IAssignment;
  scoresData: ScoreData[];
}

export const BulkGradingWrapper = ({ assignment, scoresData, ...rest }: BulkGradingWrapperProps) => {
  const modalManager = useModalManager();

  return (
    <>
      <BulkGradingButton
        modalManager={modalManager}
        {...rest}
      />

      {modalManager.isOpen && (
        <BulkGradingModal
          assignment={assignment}
          isOpen={modalManager.isOpen}
          closeModal={modalManager.close}
          scoresData={scoresData}
        />
      )}
    </>
  );
};
